import './Documents.css';

const Documents = () => {
    return <h1>Documents here</h1>;
  };
  
  export default Documents;